import { Component, OnInit, Input } from '@angular/core';
import { LocalStorageService } from 'src/app/utils/local-storage.service';
import constant from './../../../app.constant'
@Component({
  selector: 'app-google-direction',
  templateUrl: './google-direction.component.html',
  styleUrls: ['./google-direction.component.scss']
})
export class GoogleDirectionComponent implements OnInit {

  @Input() directionData: any;
  @Input() markerData: any;
  public constant: any = constant
  // latitude: number = 44.6476;
  // longitude: number = -63.5728;
  zoom: number = 10;
  latitude: number;
  longitude: number;
  constructor(private localData: LocalStorageService,) {

  }
  ngOnInit() {
    setTimeout(async () => {
      this.getlocation();
    }, 1000)
  }
  getlocation() {
    // this.latitude = parseFloat(this.localData.getItem(constant.localStorage.lat));
    // this.longitude = parseFloat(this.localData.getItem(constant.localStorage.long));
  }
  onMapReady(map: any) {
    this.getlocation();
    this.markerData.lat = Number(this.markerData?.lat)
    this.markerData.long = Number(this.markerData?.long)
    var directionsService = new google.maps.DirectionsService();
    var directionsRenderer = new google.maps.DirectionsRenderer();
    directionsRenderer.setMap(map);
    var start = new google.maps.LatLng(this.directionData?.origin?.latitude || 0, this.directionData?.origin?.longitude || 0);
    var end = new google.maps.LatLng(this.directionData?.destination?.latitude || 0, this.directionData?.destination?.longitude || 0);
    directionsService.route({
      origin: start,
      destination: end,
      waypoints: [],
      optimizeWaypoints: true,
      travelMode: google.maps.TravelMode.DRIVING,
    }, (response, status) => {
      if (status === 'OK') {
        directionsRenderer.setDirections(response);
        // If you'll like to display an info window along the route
        // middleStep is used to estimate the midpoint on the route where the info window will appear
        // const middleStep = (response.routes[0].legs[0].steps.length / 2).toFixed();
        // const infowindow2 = new google.maps.InfoWindow();
        // infowindow2.setContent(`${response.routes[0].legs[0].distance.text} <br> ${response.routes[0].legs[0].duration.text}  `);
        // infowindow2.setPosition(response.routes[0].legs[0].steps[middleStep].end_location);
        // infowindow2.open(map);
      } else {
        console.log('Directions request failed due to ' + status);
      }
    });

  }
}
